import React, { Component, Fragment } from 'react';
import { reduxForm, Field } from 'redux-form';
import { withRouter } from 'react-router';
import { trim } from 'lodash';
import { Form, Grid, Icon } from 'semantic-ui-react';

import { SelectField, InputField } from 'Common/SemanticWrapper';
import { MEALS_EQUIVALENT_SETUP_FORM_NAME, InputMode } from 'Common/FormEnum';
import { MealEquivalentSetupEnum as Fields } from 'Common/FieldEnum';
import { formatDecimal } from 'Common/FormHelper';

import 'Styles/pages/mealequivalentsetup/mealequivalentstyle.less';

class MealsEquivalentFormContainter extends Component {
  buildFiscalYears = () => {
    return this.props.fiscalYears.map((element, index) => {
      return {
        key: index,
        value: element,
        text: element.toString(),
      };
    });
  };

  render() {
    const { isFieldDisabled } = this.props;
    return (
      <Fragment>
        <Form name="MealsEquivalent">
          <Grid>
            <Grid>
              <Grid.Row>
                <Grid.Column width={3}>
                  <Field
                    label={'Fiscal Year'}
                    name={Fields.FiscalYear}
                    options={this.buildFiscalYears()}
                    component={SelectField}
                    onChange={(e, data) => this.props.getGridData(data)}
                  />
                </Grid.Column>
              </Grid.Row>
              <Grid.Row>
                <Grid.Column width={5}>
                  <Field
                    label={'Breakfast to Lunch'}
                    type="text"
                    name={Fields.BreakfastToLunch}
                    component={InputField}
                    mode={InputMode.Decimal}
                    formatOnBlur={formatDecimal(2)}
                    disabled={isFieldDisabled}
                  />
                </Grid.Column>
                <Grid.Column width={5}>
                  <Field
                    label={'Snack to Lunch'}
                    name={Fields.SnackToLunch}
                    component={InputField}
                    mode={InputMode.Decimal}
                    formatOnBlur={formatDecimal(2)}
                    disabled={isFieldDisabled}
                  />
                </Grid.Column>
                <Grid.Column width={5}>
                  <Field
                    iconPosition={'left'}
                    icon={<Icon name="dollar" />}
                    label={'A La Carte'}
                    name={Fields.SupplementalToLunch}
                    component={InputField}
                    mode={InputMode.Decimal}
                    formatOnBlur={formatDecimal(2)}
                    disabled={isFieldDisabled}
                  />
                </Grid.Column>
              </Grid.Row>
              <Grid.Row />
            </Grid>
          </Grid>
        </Form>
      </Fragment>
    );
  }
}

const validate = values => {
  const errors = {};

  if (!values[Fields.FiscalYear]) {
    errors[Fields.FiscalYear] = 'Fiscal Year must be selected.';
  }

  if (trim(values[Fields.BreakfastToLunch]).length === 0) {
    errors[Fields.BreakfastToLunch] = 'Breakfast to Lunch value required.';
  }

  if (values[Fields.BreakfastToLunch] > 999) {
    errors[Fields.BreakfastToLunch] = 'Value must be below 1000.';
  }

  if (trim(values[Fields.SnackToLunch]).length === 0) {
    errors[Fields.SnackToLunch] = 'Snack to Lunch value required.';
  }
  if (values[Fields.SnackToLunch] > 999) {
    errors[Fields.SnackToLunch] = 'Value must be below 1000.';
  }

  if (trim(values[Fields.SupplementalToLunch]).length === 0) {
    errors[Fields.SupplementalToLunch] = 'A La Carte value required.';
  }
  if (values[Fields.SupplementalToLunch] > 999) {
    errors[Fields.SupplementalToLunch] = 'Value must be below 1000.';
  }
  return errors;
};

export const MealsEquivalentForm = reduxForm({
  form: MEALS_EQUIVALENT_SETUP_FORM_NAME,
  validate,
  destroyOnUnmount: false,
})(withRouter(MealsEquivalentFormContainter));



// WEBPACK FOOTER //
// ./src/pages/mealequivalentsetup/components/MealEquivalentSetupForm.js